<template>
  <div class="container-fluid adp-admin-container-fluid">
    <div class="row">
      <div class="col">
        <div class="dropdown mr-1" style="display: inline;">
          <button class="btn adp-btn dropdown-toggle" type="button" id="rolesMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{ $t('admin.roles') }}
          </button>
          <div class="dropdown-menu" aria-labelledby="rolesMenuButton">
            <div class="dropdown-item" @click="selectedRole = 'employees'">
              {{ $t('role.employees') }}
              <span v-if="selectedRole === 'employees'">&nbsp;&nbsp;&nbsp;<img src="/images/check-mark.svg" alt=""></span>
            </div>
            <div class="dropdown-item" @click="selectedRole = 'hrs'">
              {{ $t('role.hr') }}
              <span v-if="selectedRole === 'hrs'">&nbsp;&nbsp;&nbsp;<img src="/images/check-mark.svg" alt=""></span></div>
            <div class="dropdown-item" @click="selectedRole = 'managers'">
              {{ $t('role.managers') }}
              <span v-if="selectedRole === 'managers'">&nbsp;&nbsp;&nbsp;<img src="/images/check-mark.svg" alt=""></span>
            </div>
            <div class="dropdown-item" @click="selectedRole = 'functional_managers'">
              {{ $t('role.fmanagers') }}
              <span v-if="selectedRole === 'functional_managers'">&nbsp;&nbsp;&nbsp;<img src="/images/check-mark.svg" alt=""></span>
            </div>
          </div>
        </div>

        <button type="button" class="btn adp-btn mr-1" @click="createNew()">
          {{ addNewUser }}
        </button>

        <div class="dropdown" style="display: inline;" v-if="selectedRole === 'employees'">
          <button type="button" class="btn adp-btn js-show-modal-report" id="reportsMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{ $t('admin.report_button') }}
          </button>
          <div class="dropdown-menu" aria-labelledby="reportsMenuButton">
            <a class="dropdown-item btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin"
               @click="downloadIdpReport">{{ $t('voc.report_idp') }}
            </a>
            <a class="dropdown-item btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin"
               @click="downloadMandatoryLearningReport">{{ $t('voc.report_mandatory_learning') }}
            </a>
            <a class="dropdown-item btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin"
               @click="downloadTrainingDaysEmployeesReport">{{ $t('voc.report_training_days_employees') }}
            </a>
            <a class="dropdown-item btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin"
               @click="downloadTrainingDaysResultReport">{{ $t('voc.report_training_days_trainings') }}
            </a>
            <a class="dropdown-item btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin"
               @click="downloadWishesReport">{{ $t('voc.report_wishes') }}
            </a>
            <a class="dropdown-item btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin"
               @click="downloadIdpStatusReport">{{ $t('modal.idp_export_idp_status') }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <div v-if="loading">{{ $t('voc.loading') }}</div>
    <div class="adp-grid-table" v-if="!loading">
      <div :class="selectedRole === 'managers' || selectedRole === 'functional_managers' ? 'adp-grid-row adp-grid-row__managers' : 'adp-grid-row adp-grid-row__admin'">
        <div class="d-flex flex-column adp-grid-cell__head" style="padding: 0 16px">
          <div @click="sortChange('pernumber')">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'pernumber'}">
              {{ $t('voc.table_pernumber') }}
            </span>
            <span class="adp-th adp-th__sort__icon">
              <img :src="getSortingIcon('pernumber')" alt="sort">
            </span>
          </div>
          <input @input="searchEmployees" type="text" class="adp-input adp-input__catalog adp-input-search" v-model="filterPernumber"
            @beforeinput="validateIntegerInput($event)">
        </div>
        <div class="d-flex flex-column adp-grid-cell__head">
          <div @click="sortChange('name')">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'name'}">
              {{ $t('admin.employee') }}
            </span>
            <span class="adp-th adp-th__sort__icon">
              <img :src="getSortingIcon('name')" alt="sort">
            </span>
          </div>
          <input @input="searchEmployees" type="text" class="adp-input adp-input__catalog adp-input-search" v-model="filterName">
        </div>

        <div class="d-flex flex-column adp-grid-cell__head">
          <div @click="sortChange('company')">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'company'}">
              {{ $t('admin.company') }}
            </span>
            <span class="adp-th adp-th__sort__icon">
              <img :src="getSortingIcon('company')" alt="sort">
            </span>
          </div>
          <my-dropdown :options="companies" :init-selected="filterCompany" :has-select-all="true" :localize="false"
                       v-on:my-change="onDropdownUpdate($event, 'filterCompany', 'companies')" :readonly="false">
          </my-dropdown>
        </div>

        <template v-if="selectedRole === 'employees'">
          <div class="d-flex flex-column adp-grid-cell__head">
            <div @click="sortChange('position')">
              <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'position'}">
                {{ $t('admin.position') }}
              </span>
              <span class="adp-th adp-th__sort__icon">
                <img :src="getSortingIcon('position')" alt="sort">
              </span>
            </div>
            <my-dropdown :options="positions" :init-selected="filterPosition" :has-select-all="true" :localize="false"
                         v-on:my-change="onDropdownUpdate($event, 'filterPosition', 'positions')" :readonly="false">
            </my-dropdown>
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <div @click="sortChange('whiteList')">
              <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'whiteList'}">
                {{ $t('admin.in_white_list') }}
              </span>
              <span class="adp-th adp-th__sort__icon">
                <img :src="getSortingIcon('whiteList')" alt="sort">
              </span>
            </div>
            <my-dropdown :options="whiteLists" :init-selected="filterWhiteList" :has-select-all="true" :localize="false"
                         v-on:my-change="onDropdownUpdate($event, 'filterWhiteList', 'whiteLists')" :readonly="false">
            </my-dropdown>
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <div @click="sortChange('fired')">
              <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortColumn === 'fired'}">
                {{ $t('voc.table_status') }}
              </span>
              <span class="adp-th adp-th__sort__icon">
                <img :src="getSortingIcon('fired')" alt="sort">
              </span>
            </div>
            <my-dropdown :options="firedTypes" :init-selected="filterFired" :has-select-all="true"
                         v-on:my-change="onDropdownUpdate($event, 'filterFired', 'firedTypes')" :localize="false">
            </my-dropdown>
          </div>
        </template>

        <template v-if="selectedRole === 'hrs'">
          <div>
            <div class="d-flex flex-column adp-grid-cell__head adp-th mb-3">{{ $t('admin.connections') }}</div>
            <div class="d-flex flex-column adp-grid-cell__head adp-th mt-0">{{ $t('admin.company') }}</div>
          </div>
          <div class="d-flex flex-column adp-grid-cell__head adp-th">{{ $t('admin.chapter') }}</div>
        </template>

        <template v-if="selectedRole === 'managers' || selectedRole === 'functional_managers'">
          <div>
            <div class="d-flex flex-column adp-grid-cell__head adp-th mb-3">{{ $t('admin.employee') }}</div>
            <div class="d-flex flex-column adp-grid-cell__head adp-th mt-0">{{ $t('admin.fio') }}</div>
          </div>
          <div class="d-flex flex-column adp-grid-cell__head adp-th">{{ $t('admin.tab_number') }}</div>
        </template>
      </div>
      <div :class="selectedRole === 'managers' || selectedRole === 'functional_managers' ? 'adp-grid-row adp-grid-row__managers' : 'adp-grid-row adp-grid-row__admin'" v-for="(item, i) in items" :key="i" v-if="employees"
           @mouseenter="enterToListItem(i)" @mouseleave="leaveFromListItem()"
           :style="currentItemIndex === i ? 'backgroundColor: #F5F5F5' : ''">
        <div class="adp-grid-cell adp-grid-cell__code align-self-baseline" style="padding: 0 16px">
            {{ item.pernumber }}
        </div>
        <div class="adp-grid-cell adp-grid-cell__title align-self-baseline">
            {{ item.fullname }}
        </div>
        <div class="adp-grid-cell adp-grid-cell__title align-self-baseline">
            {{ item.company_name }}
        </div>

        <template v-if="selectedRole === 'employees'">
          <div class="adp-grid-cell adp-grid-cell__title">
            {{ item.position_name }}
          </div>
          <div class="adp-grid-cell adp-grid-cell__title">
            {{ item.added_by === 1 ? $t('voc.no') : $t('voc.yes') }}
          </div>
          <div class="adp-grid-cell adp-grid-cell__title">
            {{ item.fired_at && item.fired_at === '9000-01-01' ? $t('voc.active') : $t('voc.fired') }}
          </div>
        </template>

        <template v-if="selectedRole === 'hrs'">
          <div class="d-flex flex-column">
            <div class="adp-grid-cell adp-grid-cell__title" style="height: 5rem" v-for="item in item.companies">
              <div>{{ item.company.name }}</div>
            </div>
          </div>
          <div class="d-flex flex-column">
            <div class="adp-grid-cell adp-grid-cell__title" style="height: 5rem" v-for="item in item.companies">
              <div>{{ item.department.name }}</div>
            </div>
          </div>
        </template>

        <template v-if="selectedRole === 'managers' || selectedRole === 'functional_managers'">
          <div class="d-flex flex-column" style="width: max-content;">
            <div class="adp-grid-cell adp-grid-cell__title" v-for="item in item.employees">
              <div>{{ item.name }}</div>
            </div>
          </div>
          <div class="d-flex flex-column">
            <div class="adp-grid-cell adp-grid-cell__title" v-for="item in item.employees">
              <div>{{ item.pernumber }}</div>
            </div>
          </div>
        </template>

        <div class="d-flex justify-content-between pr-5 pl-4">
          <template v-if="selectedRole === 'employees' && currentItemIndex === i">
            <img src="/images/show.svg" style="width: 17px; cursor: pointer" @click="openEmployeeInNewTab(item)">
            <img src="/images/edit.svg" style="width: 17px; cursor: pointer" @click="editEmployee(item)">
            <img src="/images/delete.svg" style="width: 17px; cursor: pointer" @click="deleteEmployee(item)" v-if="item.added_by !== 1">
            <img src="/images/delete.svg" style="width: 17px; cursor: pointer"  v-if="item.added_by === 1"
                 v-tooltip.top-start="{ content: $t('admin.not_delete') }">
          </template>
          <template v-if="selectedRole === 'hrs' && currentItemIndex === i">
            <div class="d-flex flex-column">
              <div v-for="hrdata in item.companies" class="adp-grid-cell" style="height: 5rem">
                <img src="/images/delete.svg" style="width: 17px; cursor: pointer;" @click="deleteHrsLink(hrdata, item.fullname)">
              </div>
            </div>
          </template>
          <template v-if="(selectedRole === 'managers' || selectedRole === 'functional_managers') && currentItemIndex === i">
            <div class="d-flex flex-column">
              <div v-for="employee in item.employees" class="adp-grid-cell" style="height: 47px">
                <img src="/images/delete.svg" style="width: 17px; cursor: pointer;" @click="deleteManagersLink(employee, item)">
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div class="adp-pagination mt-4" v-if="!loading">
      <div class="adp-pagination-bnt" v-for="(page, index) in pages" v-if="page.url || page.label === '...'" @click="changePage(page.label)"
           :class="{'adp-pagination-bnt__active': page.active}">
        <span v-if="page.label === 'pagination.previous' && page.url"><</span>
        <span v-else-if="page.label === 'pagination.next' && page.url">></span>
        <span v-else>{{ page.label }}</span>
      </div>
      <div style="width: 190px; margin-left: 30px">
        <v-select style="background-color: white" label="text"
                  :options="itemsPerPage"
                  :clearable="false"
                  v-model="itemsPerPageSelected"
                  @option:selecting="selectItemsPerPage($event)"
        >
        </v-select>
      </div>
    </div>

    <!-- Modals -->
    <employee-view-modal :employee="currentEmployee" @employee-updated="getEmployees()"/>
    <employee-create-modal @employee-created="getEmployees()" />
    <manager-create-modal :manager-type="selectedRole" :employees-list="employeesList" @manager-created="getEmployees()" />
    <hr-create-modal :employees-list="employeesList" @hr-created="getEmployees()" />
    <delete-employee-question-modal :employee="currentEmployee" @employee-deleted="getEmployees()" />
    <delete-hrs-link-question-modal :hrs-data="selectedHrsData" @hrs-link-deleted="getEmployees()" />
    <delete-managers-link-question-modal :manager-data="selectedManagerData" :manager-type="selectedRole" @managers-link-deleted="getEmployees()" />
    <mass-idp-export-modal :pernumbers="pernumbers" :export-type="exportType"/>
    <mass-mandatory-export-modal :pernumbers="pernumbers" />
    <mass-training-export-modal :pernumbers="pernumbers" :export-type="trainingExportType" />
    <mass-idp-status-export-modal :pernumbers="pernumbers" />
    <reports-modal v-show="isReportsOpened" :is-reports-opened="isReportsOpened" @close-reports-modal="isReportsOpened = false"/>
  </div>
</template>

<script>
import {debounce} from 'lodash';
import MyDropdown from "../MyDropdown";
import api from "../../api";
import EmployeeViewModal from "./EmployeeViewModal";
import EmployeeCreateModal from "./EmployeeCreateModal";
import DeleteEmployeeQuestionModal from "./DeleteEmployeeQuestionModal";
import HrCreateModal from "./HrCreateModal";
import DeleteHrsLinkQuestionModal from "./DeleteHrsLinkQuestionModal";
import DeleteManagersLinkQuestionModal from "./DeleteManagersLinkQuestionModal";
import ManagerCreateModal from "./ManagerCreateModal";
import MassIdpExportModal from "../modals/exports/MassIdpExport.vue";
import MassTrainingExportModal from "../modals/exports/MassTrainingExport.vue";
import MassMandatoryExportModal from "../modals/exports/MassMandatoryExport.vue";
import MassIdpStatusExport from "../modals/exports/MassIdpStatusExport.vue";
import ReportsModal from "../modals/ReportsModal.vue";

export default {
  name: "AdminPage",
  components: {
    'manager-create-modal': ManagerCreateModal,
    'delete-managers-link-question-modal': DeleteManagersLinkQuestionModal,
    'delete-hrs-link-question-modal': DeleteHrsLinkQuestionModal,
    'hr-create-modal': HrCreateModal,
    'delete-employee-question-modal': DeleteEmployeeQuestionModal,
    'employee-create-modal': EmployeeCreateModal,
    'employee-view-modal': EmployeeViewModal,
    'my-dropdown': MyDropdown,
    'mass-idp-export-modal': MassIdpExportModal,
    'mass-training-export-modal': MassTrainingExportModal,
    'mass-mandatory-export-modal': MassMandatoryExportModal,
    'mass-idp-status-export-modal': MassIdpStatusExport,
    'reports-modal': ReportsModal,
  },
  data: function () {
    return {
      loading: false,

      currentItemIndex: null,
      currentEmployee: {},
      selectedRole: 'employees',

      selectedHrsData: {},
      selectedManagerData: {},

      activePage: 1,
      itemsPerPageCount: 20,
      itemsPerPage: [
        {number: 20, text: `20 ${this.$t('idp.per_page')}`},
        {number: 50, text: `50 ${this.$t('idp.per_page')}`},
        {number: 100, text:`100 ${this.$t('idp.per_page')}`},
      ],
      pages: [],

      items: [],
      employees: [],

      sortingPernumber: null,
      sortingName: null,
      sortingCompany: null,
      sortingPosition: null,
      sortingWhiteList: null,
      sortingFired: null,
      sortColumn: '',
      sortDirection: '',
      lastUsedFilterOptions: '',

      filterPernumber: '',
      filterName: '',
      filterCompany: [],
      filterPosition: [],
      filterWhiteList: [],
      filterFired: [],

      companies: [],
      positions: [],
      whiteLists: [],
      firedTypes: [],

      pernumbers: [],
      exportType: 'idp',
      trainingExportType: 'employees',

      employeesList: [],

      reportsButton: document.getElementById('reports-download'),
      reportsLoadingButton: document.getElementById('reports-download-circle'),
      isReportsOpened: false,
    }
  },
  computed: {
    itemsPerPageSelected: {
      get() {
        return this.itemsPerPage.find(item => item.number === this.itemsPerPageCount).text
      },
      set({number}) {
        this.itemsPerPageCount = number;
      }
    },
    addNewUser() {
      if (this.selectedRole === 'employees') return this.$t('admin.new_emp')
      if (this.selectedRole === 'hrs') return this.$t('admin.new_hr')
      if (this.selectedRole === 'managers') return this.$t('admin.new_manager')
      if (this.selectedRole === 'functional_managers') return this.$t('admin.new_functional_manager')
    },
    noFilersSelected() {
      return this.filterPernumber === '' && this.filterName === ''
        && this.filterCompany.length === 0 && this.filterPosition.length === 0 && this.filterWhiteList.length === 0
    }
  },
  watch: {
    async selectedRole(role) {
      this.loading = true;
      this.activePage = 1;
      const data = {
        page: this.activePage,
        count: this.itemsPerPageCount,
        role: role,
      };
      const resp = await api.getEmployeesList(data);
      this.employees = resp.data.data;
      this.pages = resp.data.links;
      await this.filterEmployee();
      this.loading = false;
    }
  },
  methods: {
    async getFilterOptions(filters) {
      const resp = await api.getEmployeesListFilters(filters);

      if (this.lastUsedFilterOptions !== 'positions' || this.filterPosition.length === 0) {
      this.positions = resp.data.position.map(item => ({id: String(item), code: String(item)}));
      }
      if (this.lastUsedFilterOptions !== 'companies' || this.filterCompany.length === 0) {
        this.companies = resp.data.company.map(item => ({id: String(item), code: String(item)}));
      }

      if (this.lastUsedFilterOptions !== 'whiteLists' || this.filterWhiteList.length === 0) {
        const uniqueWhiteLists = resp.data.whiteLists;
        this.whiteLists = [];
        if (uniqueWhiteLists.includes(1)) this.whiteLists.push({id: 1, code: this.$t('voc.no')});
        if (uniqueWhiteLists.includes(2)) this.whiteLists.push({id: 2, code: this.$t('voc.yes')});
      }

      if (this.lastUsedFilterOptions !== 'firedTypes' || this.filterFired.length === 0) {
        const uniqueFiredTypes = resp.data.firedTypes;
        this.firedTypes = [];
        if (uniqueFiredTypes.includes('active')) this.firedTypes.push({id: 'active', code: this.$t('voc.active')});
        if (uniqueFiredTypes.includes('fired')) this.firedTypes.push({id: 'fired', code: this.$t('voc.fired')});
      }
    },
    async getEmployees() {
      this.loading = true;
      const data = {
        page: this.activePage,
        count: this.itemsPerPageCount,
        role: this.selectedRole,
      };
      const resp = await api.getEmployeesList(data);
      this.employees = resp.data.data;
      this.pages = resp.data.links;
      await this.filterEmployee();
      this.loading = false;
    },
    sortChange(sortingColumn) {
      if (sortingColumn !== this.sortColumn) {
        this.sortColumn = sortingColumn;
        this.sortDirection = '';
      }

      if (this.sortDirection === '') {
        this.sortDirection = 'asc';
      } else if (this.sortDirection === 'asc') {
        this.sortDirection = 'desc';
      } else if (this.sortDirection === 'desc') {
        this.sortDirection = '';
        this.sortColumn = null;
      }

      this.filterEmployee();
    },
    onDropdownUpdate(e, property, filterOptionsName) {
      this.lastUsedFilterOptions = filterOptionsName;
      this[property] = e;
      if (this.activePage > 1) this.changePage(1);
      this.filterEmployee();
    },
    searchEmployees: debounce(function () {
      if (this.activePage > 1) this.changePage(1);
      this.filterEmployee();
    }, 700),
    getSortingIcon(sortingColumn) {
      if (sortingColumn !== this.sortColumn || this.sortDirection === '') {
        return '/images/sort.svg';
      } else if (this.sortDirection === 'asc') {
        return '/images/sort_active_asc.svg';
      } else if (this.sortDirection === 'desc') {
        return '/images/sort_active_desc.svg';
      }
    },
    async filterEmployee() {
      let items = this.employees;
      items = await this.searchItems();

      this.items = JSON.parse(JSON.stringify(items));
    },
    async searchItems() {
      let items = this.allItems;
      const data = {
        page: this.activePage,
        count: this.itemsPerPageCount,
        role: this.selectedRole,
        search_pernumber: this.filterPernumber,
        search_name: this.filterName,
        search_company: this.filterCompany,
        search_position: this.filterPosition,
        search_white_list: this.filterWhiteList,
        search_fired: this.filterFired,
        sort_column: this.sortColumn,
        sort_direction: this.sortDirection,
      };

      await this.getFilterOptions(data);

      let resp = await api.getEmployeesList(data);
      items = resp.data.data;
      this.pages = resp.data.links;

      return items;
    },
    async selectItemsPerPage(event) {
      this.loading = true;
      try {
        event.number > 20 ? this.activePage = 1 : this.activePage
        const data = {
          page: this.activePage,
          count: event.number,
          role: this.selectedRole,
        };
        let resp = await api.getEmployeesList(data);
        this.employees = resp.data.data;
        this.pages = resp.data.links;

        await this.filterEmployee();
      } catch (e) {
        console.error(e);
      }
      this.loading = false;
    },
    changePage(val) {
      if(val === '...') {
        return;
      }

      if(val === 'pagination.previous') {
        val = Number(this.activePage) - 1;
      }

      if(val === 'pagination.next') {
        val = Number(this.activePage) + 1;
      }

      val = Number(val);

      this.activePage = val;
      if (val === 1) {
        val = null;
      }
      this.getEmployees();
    },
    enterToListItem(index) {
      this.currentItemIndex = index;
    },
    leaveFromListItem() {
      this.currentItemIndex = null;
    },
    openEmployeeInNewTab(employee) {
      let routeData = this.$router.resolve({ name: `${this.$role}-employee`, params: { pernumber: employee.pernumber }});
      window.open(routeData.href, '_blank');
    },
    editEmployee(employee) {
      this.currentEmployee = employee;
      this.$nextTick(() => this.$bvModal.show('employee-view-modal'));
    },
    deleteEmployee(employee) {
      this.currentEmployee = employee;
      if (this.selectedRole === 'employees') this.$nextTick(() => this.$bvModal.show('delete-employee-question-modal'));
    },
    deleteHrsLink(hrData, hrName) {
      this.selectedHrsData = {
        fio: hrName,
        pernumber: hrData.pernumber,
        company: hrData.company,
        department: hrData.department,
      };
      this.$nextTick(() => this.$bvModal.show('delete-hrs-link-question-modal'));
    },
    deleteManagersLink(managerEmployee, manager) {
      this.selectedManagerData = {
        subordinate: managerEmployee.pernumber,
        subordinateName: managerEmployee.fullname,
        manager: manager.pernumber,
        managerFio: manager.fullname
      };
      this.$nextTick(() => this.$bvModal.show('delete-managers-link-question-modal'));
    },
    createNew() {
      if (this.selectedRole === 'employees') this.$bvModal.show('employee-create-modal');
      if (this.selectedRole === 'hrs') this.$bvModal.show('hr-create-modal');
      if (this.selectedRole === 'managers' || this.selectedRole === 'functional_managers') this.$bvModal.show('manager-create-modal');
    },
    async downloadIdpReport() {
      if (this.noFilersSelected) {
        this.pernumbers = this.employeesList.map(x => x.pernumber);
      } else {
        const employees = await this.getEmployeesFioListWithFilters();
        this.pernumbers = employees.map(x => x.pernumber);
      }
      this.exportType = 'idp';
      this.$nextTick(() => this.$bvModal.show('mass-idp-export-modal'));
    },

    async downloadMandatoryLearningReport() {
      if (this.noFilersSelected) {
        this.pernumbers = this.employeesList.map(x => x.pernumber);
      } else {
        const employees = await this.getEmployeesFioListWithFilters();
        this.pernumbers = employees.map(x => x.pernumber);
      }

      this.$nextTick(() => this.$bvModal.show('mass-mandatory-export-modal'));
    },

    async downloadTrainingDaysEmployeesReport() {
      if (this.noFilersSelected) {
        this.pernumbers = this.employeesList.map(x => x.pernumber);
      } else {
        const employees = await this.getEmployeesFioListWithFilters();
        this.pernumbers = employees.map(x => x.pernumber);
      }
      this.trainingExportType = 'employees';
      this.$nextTick(() => this.$bvModal.show('mass-training-export-modal'));
    },

    async downloadTrainingDaysResultReport() {
      if (this.noFilersSelected) {
        this.pernumbers = this.employeesList.map(x => x.pernumber);
      } else {
        const employees = await this.getEmployeesFioListWithFilters();
        this.pernumbers = employees.map(x => x.pernumber);
      }
      this.trainingExportType = 'result';
      this.$nextTick(() => this.$bvModal.show('mass-training-export-modal'));
    },

    async downloadWishesReport() {
      if (this.noFilersSelected) {
        this.pernumbers = this.employeesList.map(x => x.pernumber);
      } else {
        const employees = await this.getEmployeesFioListWithFilters();
        this.pernumbers = employees.map(x => x.pernumber);
      }
      this.exportType = 'wish';
      this.$nextTick(() => this.$bvModal.show('mass-idp-export-modal'));
    },
    async downloadIdpStatusReport() {
      if (this.noFilersSelected) {
        this.pernumbers = this.employeesList.map(x => x.pernumber);
      } else {
        const employees = await this.getEmployeesFioListWithFilters();
        this.pernumbers = employees.map(x => x.pernumber);
      }
      this.$nextTick(() => this.$bvModal.show('mass-idp-status-export-modal'));
    },
    async getEmployeesFioList() {
      try {
        let res = await api.getEmployeesFio(1);
        this.employeesList = res.data;
      } catch (e) {
        console.log(e);
      }
    },
    async getEmployeesFioListWithFilters() {
      const data = {
        company: this.filterCompany,
        position: this.filterPosition,
        white_list: this.filterWhiteList,
      };

      let employees = [];

      try {
        let res = await api.getEmployeesFioWithFilters(data);
        employees = res.data;
      } catch (e) {
        console.log(e);
      }

      return employees;
    },
  },
  async mounted() {
    await this.getEmployees();
    await this.getEmployeesFioList();

    this.reportsButton.onclick = () => this.isReportsOpened = !this.isReportsOpened;
    this.reportsLoadingButton.onclick = () => this.isReportsOpened = !this.isReportsOpened;
  }
}
</script>
